import React from 'react';
import { Box } from '@drone-js/core';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps, mapTopDestinationToSearchResult, SearchBoxContainerProps } from 'component/page/home/SearchBoxContainer/SearchBoxContainer.selectors';
import SearchBox from 'component/common/SearchBox/SearchBox';
import ErrorModal from 'component/common/ErrorModal/ErrorModal';
import TextSearchOverlay from 'component/common/TextSearch/TextSearchOverlay';
import LocationDeniedInfoModal from 'component/common/TextSearch/TextSearchResult/NearMe/LocationDeniedInfoModal';

const SearchBoxContainer: React.FC<SearchBoxContainerProps> = (props) => {
    const {
        pageTypeId,
        suggestionResult,
        travelDate,
        isNearByEnabled,
        isEmptyTextSearchAble,
        topDestinations,
        cms,
        isNewHomePageEnabled,
        onSearchResultSelect,
        setSelectedResult,
        onEmptyTextSearchButtonClick,
    } = props;
    const [searchText, setSearchText] = React.useState<string>(props.searchText);
    const [isInvalidInput, setIsInvalidInput] = React.useState<boolean>(false);
    const topDestinationList = topDestinations || [];
    const isTopDestinationListDisplay = isEmptyTextSearchAble && topDestinationList && topDestinationList.length !== 0;

    const onSearchButtonClick = () => {
        if (suggestionResult && suggestionResult.id > 0 && searchText) {
            setIsInvalidInput(false);
            props.onSearchButtonClick(suggestionResult, travelDate);
            return;
        }
        if (isTopDestinationListDisplay) {
            const searchResult = mapTopDestinationToSearchResult(topDestinationList[0]);
            setIsInvalidInput(false);
            suggestionResult && onEmptyTextSearchButtonClick(searchResult);
            return;
        }
        setIsInvalidInput(true);
    };

    return (
        <>
            <Box my={isNewHomePageEnabled ? '0' : '24'} mx={isNewHomePageEnabled ? '0' : '16'} display="flex" justifyContent="center" alignItems="center" width="100%">
                <SearchBox
                    query={searchText}
                    selected={suggestionResult}
                    onSearchButtonClick={onSearchButtonClick}
                    pageTypeId={pageTypeId}
                    inputRef={props.inputRef}
                    setSearchText={setSearchText}
                    setSelectedResult={setSelectedResult}
                    placeholderText={isTopDestinationListDisplay ? topDestinationList[0].cityName : cms[238402]}
                />
            </Box>
            <TextSearchOverlay
                selectedResult={suggestionResult}
                setSearchText={setSearchText}
                onGlobalKeywordResultSelect={props.onGlobalKeywordResultSelect}
                setSelectedResult={onSearchResultSelect}
            />
            <ErrorModal
                elementName="activities-missing-destination-error-modal"
                showModal={isInvalidInput}
                message={cms[126983]}
                buttonText={cms[126815]}
                onButtonClick={() => setIsInvalidInput(false)}
            />
            {isNearByEnabled && <LocationDeniedInfoModal />}
        </>
    );
};
SearchBoxContainer.displayName = 'SearchBoxContainer';

export default connect(mapStateToProps, mapDispatchToProps)(SearchBoxContainer);
